// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3BtFa","content":"LoadingAlert_content__2yT5F"};